export const downloadFileFromUrl = (fileUrl, fileName) => {
  if (!fileUrl) {
    return;
  }
  const link = document.createElement('a');
  link.href = fileUrl;
  link.download = fileName;
  link.click(); // return
};

export const networkToolDagActions = {
  RUN: 'Run',
  EDIT: 'Edit',
  DELETE: 'Delete',
  DEQUEUE: 'Dequeue',
  COMPLETE: 'Complete',
  STOP: 'Stop',
  RE_RUN: 'Re_run',
  DOWNLOAD: 'Download'
};

export const networkToolDagStatus = {
  READY: 'READY',
  INCOMPLETE: 'INCOMPLETE',
  QUEUED: 'QUEUED',
  RUNNING: 'RUNNING',
  STOPPED: 'STOPPED',
  COMPLETE: 'COMPLETE',
  SUCCESS: 'SUCCESS',
  FAILED: 'FAILED'
};

export const networkRoles = {
  ROLE_SAVE_CONFIG_NETWORK_TOOL: 'ROLE_SAVE_CONFIG_NETWORK_TOOL',
  ROLE_RUN_NETWORK_TOOL: 'ROLE_RUN_NETWORK_TOOL'
};
